import { CeColourField } from "../../generic/components/form-fields/ce-colour-field";
import { CeSlider } from "../../generic/components/form-fields/ce-slider";
import { FormStack } from "../../generic/components/form-fields/form-stack";

import type { EmailDesignSchema } from "../../email-design/types/email-design-type";
import type { FC } from "react";
import type { Path } from "react-hook-form";

const ButtonSettingsEditor: FC<{ button: "primary" | "secondary" }> = ({ button }) => {
  const name: Path<EmailDesignSchema> = `button_settings.${button}_button`;
  return (
    <FormStack>
      <CeColourField<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.color`}
        label="Text & Border Color"
      />
      <CeColourField<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.background_color`}
        label="Background Color"
      />
      <CeSlider<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.font_size`}
        label="Font Size"
        min={16}
        max={64}
        step={2}
      />
      <CeSlider<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.border`}
        label="Border Width"
        min={0}
        max={20}
      />
      <CeSlider<EmailDesignSchema>
        analyticsCategory="email_design"
        name={`${name}.border_radius`}
        label="Border Radius"
        min={0}
        max={100}
      />
    </FormStack>
  );
};

export const PrimaryButtonSettingsEditor: FC = () => <ButtonSettingsEditor button="primary" />;
export const SecondaryButtonSettingsEditor: FC = () => <ButtonSettingsEditor button="secondary" />;
